import moment from "moment";

export const calculateDurationToPlayAlert = async (sessionStartTime, disableLaunchSessionAfterMinutes) => {
    const now = moment();
    const startTime = moment(sessionStartTime);
    const disableTime = startTime.add(disableLaunchSessionAfterMinutes, 'minutes');

    let durationSeconds = 0;

    if (now.isBefore(startTime) || now.isBefore(disableTime)) {
        durationSeconds = disableTime.diff(now, 'seconds');
    }
    
    return durationSeconds;
}

export const constructAudioBufferAndPlayAlert = async (silentAudioFile, alertAudioFile, durationSeconds) => {
    const audioContext = new window.AudioContext();
    
    const fetchedSilentAudioFile = await fetch(silentAudioFile);
    const silentAudioFileArrayBuffer = await fetchedSilentAudioFile.arrayBuffer();
    const silentAudioFileAudioBuffer = await audioContext.decodeAudioData(silentAudioFileArrayBuffer);

    const fetchedAlertAudioFile = await fetch(alertAudioFile);
    const alertAudioFileArrayBuffer = await fetchedAlertAudioFile.arrayBuffer();
    const alertAudioFileAudioBuffer = await audioContext.decodeAudioData(alertAudioFileArrayBuffer);

    const audioRepeatCount = Math.ceil(durationSeconds / silentAudioFileAudioBuffer.duration);
    const maxChannels = Math.max(silentAudioFileAudioBuffer.numberOfChannels, alertAudioFileAudioBuffer.numberOfChannels);
    const silentAudioLength = (silentAudioFileAudioBuffer.length * audioRepeatCount) + alertAudioFileAudioBuffer.length;
    const extendedAudioBuffer = audioContext.createBuffer(maxChannels, silentAudioLength, silentAudioFileAudioBuffer.sampleRate);

    for (let i = 0; i < audioRepeatCount; i++) {
        for (let channel = 0; channel < silentAudioFileAudioBuffer.numberOfChannels; channel++) {
            const nowBuffering = extendedAudioBuffer.getChannelData(channel);
            const bufferToAppend = silentAudioFileAudioBuffer.getChannelData(channel);
            nowBuffering.set(bufferToAppend, i * silentAudioFileAudioBuffer.length);
        }
    }

    const channelsToProcess = Math.min(alertAudioFileAudioBuffer.numberOfChannels, extendedAudioBuffer.numberOfChannels);

    for (let channel = 0; channel < channelsToProcess; channel++) {
        const nowBuffering = extendedAudioBuffer.getChannelData(channel);
        const bufferToAppend = alertAudioFileAudioBuffer.getChannelData(channel);
        nowBuffering.set(bufferToAppend, audioRepeatCount * silentAudioFileAudioBuffer.length);
    }

    const source = audioContext.createBufferSource();
    source.buffer = extendedAudioBuffer;
    source.connect(audioContext.destination);

    try {
        source.start(0);
    } catch (e) {
        console.error("Failed to play audio: " + e);
    }
}
